/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  ReservationsAndCommitmentsCoverageOfferingType,
  ReservationsAndCommitmentsCoverageServiceUsageType,
  ReservationsAndCommitmentsLookbackPeriod,
  ReservationsRecommendationPaymentOption,
  ReservationsRecommendationTerm,
} from "~/generated/graphql";
import { UsageCoverageData } from "./types";

type State = {
  offeringType: ReservationsAndCommitmentsCoverageOfferingType;
  timePeriod: ReservationsAndCommitmentsLookbackPeriod;
  paymentOption: ReservationsRecommendationPaymentOption;
  termOption: ReservationsRecommendationTerm;
  coverageDetails: UsageCoverageData;
};

const initialCoverageData: UsageCoverageData = {
  resource: "",
  platform: "",
  region: "",
  totalOnDemandCost: "",
  coverageSavedCost: "",
  instance: "",
  instanceType: "",
  potentialSavings: "",
  hasCoverageResourceList: false,
  hasRecommendations: false,
  riCostPercent: "0",
  spCostPercent: "0",
  onDemandCostPercent: "100",
  provider: "",
  offeringType: ReservationsAndCommitmentsCoverageOfferingType.All,
  serviceUsageType: ReservationsAndCommitmentsCoverageServiceUsageType.Compute,
};
const commonState = {
  timePeriod: ReservationsAndCommitmentsLookbackPeriod.ThirtyDays,
  paymentOption: ReservationsRecommendationPaymentOption.PartialUpfront,
  termOption: ReservationsRecommendationTerm.OneYear,
  coverageDetails: initialCoverageData,
};
export const initialStateAws = {
  offeringType: ReservationsAndCommitmentsCoverageOfferingType.All,
  ...commonState,
};

export const initialStateAzure = {
  offeringType:
    ReservationsAndCommitmentsCoverageOfferingType.ReservedInstances,
  ...commonState,
};

export const enum ACTION {
  SET_OFFERING_TYPE = "SET_OFFERING_TYPE",
  SET_TIME_PERIOD = "SET_TIME_PERIOD",
  SET_PAYMENT_OPTION = "SET_PAYMENT_OPTION",
  SET_TERM_OPTION = "SET_TERM_OPTION",
  SET_COVERAGE_DETAILS = "SET_COVERAGE_DETAILS",
}

type Action =
  | {
      type: ACTION.SET_COVERAGE_DETAILS;
      payload: {
        data: UsageCoverageData;
      };
    }
  | {
      type: ACTION.SET_OFFERING_TYPE;
      payload: {
        data: ReservationsAndCommitmentsCoverageOfferingType;
      };
    }
  | {
      type: ACTION.SET_PAYMENT_OPTION;
      payload: {
        data: ReservationsRecommendationPaymentOption;
      };
    }
  | {
      type: ACTION.SET_TERM_OPTION;
      payload: {
        data: ReservationsRecommendationTerm;
      };
    }
  | {
      type: ACTION.SET_TIME_PERIOD;
      payload: {
        data: ReservationsAndCommitmentsLookbackPeriod;
      };
    };

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ACTION.SET_OFFERING_TYPE:
      return {
        ...state,
        offeringType: action.payload.data,
      };
    case ACTION.SET_TIME_PERIOD:
      return {
        ...state,
        timePeriod: action.payload.data,
      };
    case ACTION.SET_PAYMENT_OPTION:
      return {
        ...state,
        paymentOption: action.payload.data,
      };
    case ACTION.SET_TERM_OPTION:
      return {
        ...state,
        termOption: action.payload.data,
      };
    case ACTION.SET_COVERAGE_DETAILS:
      return {
        ...state,
        coverageDetails: action.payload.data,
      };
    default:
      throw new Error("Unknown action");
  }
}
